import React                         from 'react';
import Grid                          from '@mui/material/Grid';
import TextField                     from '@mui/material/TextField';
import Button                        from '@mui/material/Button';
import PhotoCamera                   from "@mui/icons-material/PhotoCamera";
import Stack                         from "@mui/material/Stack";

import HashTags                      from "./hashTags";

export default function MetaDataDown (props) {
	const { seoTitle, seoDesc, tags, imgAlt, img, imgName, onChange, handleImage, handleHashTags } = props;

	return (
		<>
		<Grid container spacing={1}>
			<Grid item xs={false} md={1} style={{backgroundColor: ''}}>
			</Grid>
			<Grid item xs={12} md={10} style={{backgroundColor: '', margin: '20px 10px 20px 20px'}}>
				<TextField
					required
					id="seo-title-required"
					label="SEO Title"
					name="seoTitle"
					value={seoTitle}
					onChange={onChange}
					style={{width: '100%'}}
				/>
			</Grid>
		</Grid>
		<Grid container spacing={1}>
			<Grid item xs={false} md={1} style={{backgroundColor: ''}}>
			</Grid>
			<Grid item xs={12} md={10} style={{backgroundColor: '', margin: '20px 10px 20px 20px'}}>
				<TextField
					required
					id="seo-desc-required"
					label="SEO Description"
					name="seoDesc"
					value={seoDesc}
					onChange={onChange}
					style={{width: '100%'}}
				/>
			</Grid>
		</Grid>
		<Grid container spacing={1}>
			<Grid item xs={false} md={1} style={{backgroundColor: ''}}>
			</Grid>
			<Grid item xs={12} md={4} style={{backgroundColor: '', margin: '20px 0 20px 20px'}}>
				<TextField
					required
					id="img-alt-required"
					label="Image Alt Text"
					name="imgAlt"
					value={imgAlt}
					onChange={onChange}
					style={{width: '100%'}}
				/>
			</Grid>
			<Grid item xs={12} md={2} style={{backgroundColor: '', margin: '30px 0 20px 10px'}}>
				<Stack direction="row" alignItems="center" spacing={2} justifyContent="center">
					<Button variant="outlined" component="label" startIcon={<PhotoCamera />} style={{textTransform: 'none'}}>
						Upload (Max 10M)
						<input hidden accept="image/*" multiple type="file" onChange={handleImage}/>
					</Button>
				</Stack>
			</Grid>
			<Grid item xs={12} md={4} style={{backgroundColor: '', display: "flex", alignItems: 'center'}}>
				{Boolean (imgName.length) && imgName}
			</Grid>
		</Grid>
		<Grid container spacing={1}>
			<Grid item xs={false} md={1} style={{backgroundColor: ''}}>
			</Grid>
			<Grid item xs={12} md={10} style={{backgroundColor: '', margin: '20px 10px 20px 20px'}}>
				<HashTags
					tags={tags}
					handleHashTags={handleHashTags}
				/>
			</Grid>
		</Grid>
		</>
	);
}
